module.exports = __webpack_public_path__ + "img/sc-1-act.696463d0.png";